
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      img: require('../assets/virus.webp'),
    }
  },
})
